export default "__VITE_ASSET__D2M4MgFG__"